import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

const QRScanner = ({ onClose }) => {
    const qrRef = useRef(null);

    useEffect(() => {
        const qr = new Html5Qrcode("qr-reader");
        qrRef.current = qr;

        const startScanner = async () => {
            try {
                await qr.start(
                    { facingMode: "environment" },
                    {
                        fps: 10,
                        qrbox: { width: 250, height: 250 },
                    },
                    (decodedText) => {
                        console.log("QR result:", decodedText);

                        qr.stop().then(() => {
                            onClose?.();
                            window.location.href = decodedText;
                        });
                    },
                    () => { }
                );
            } catch (err) {
                console.log("Camera error:", err);
            }
        };

        startScanner();

        return () => {
            if (qrRef.current) {
                qrRef.current.stop().catch(() => { });
            }
        };
    }, []);

    const handleClose = async () => {
        try {
            if (qrRef.current) {
                await qrRef.current.stop();
            }
        } catch (error) {
            console.log(error);
        }

        onClose?.();
    };

    return (
        <div className="fixed inset-0 z-50 bg-black flex flex-col items-center justify-center">
            <button
                onClick={handleClose}
                className="absolute top-4 right-4 bg-black text-white px-3 py-1 rounded"
            >
                Tutup
            </button>

            <div className="bg-white p-4 rounded-lg shadow-lg">
                <div className="text-center mb-3 font-semibold">
                    Scan QR Meja
                </div>

                <div
                    id="qr-reader"
                    style={{ width: "300px" }}
                />
            </div>

        </div>
    );
};

export default QRScanner;